import React from "react";
import "./MyApproach.css";

const MyApproach: React.FC = () => {
  return (
    <section id="my-approach" className="my-approach-section">
      <div className="my-approach-container">
        <h2 className="section-heading">My Approach</h2>
        <div className="approach-content">
          <p className="approach-text">
            I use a humanistic and gentle client- centered approach that focuses
            on building a therapeutic relationship grounded in safety, empathy
            and trust.
            {/* </p>
          <p className="approach-text"> */}
            I utilize elements of ACT, CBT, Inner Child Work, Expressive Art
            therapy and narrative therapy in my work. I truly believe that
            meaningful change can happen when we feel safe, seen, heard, and
            supported. Through this collaborative process my aim remains to help
            you reconnect with your inner resources, navigate life’s challenges,
            cultivate a greater sense of ease and clarity and support you in
            meaningful personal growth, as you move towards a more grounded and
            fulfilling connection with yourself.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MyApproach;
